import React, { useEffect, useRef, useState } from 'react';
import './index.css';
import { widget as Widget } from '../../charting_library';
import { CustomDataFeed } from '../../data-feed';

function getLanguageFromURL() {
	const regex = new RegExp('[\\?&]lang=([^&#]*)');
	const results = regex.exec(window.location.search);
	return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function getSymbolFromURL() {
	const regex = new RegExp('[\\?&]symbol=([^&#]*)');
	const results = regex.exec(window.location.search);
	return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function getThemeFromURL() {
	const regex = new RegExp('[\\?&]theme=([^&#]*)');
	const results = regex.exec(window.location.search);
	return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}


const DATA_FEED_URL = process.env.REACT_APP_DATA_FEED_URL
const WS_URL = process.env.REACT_APP_WS_URL || 'wss://staging-socket.solmemes.lol'

export const TVChartContainer = () => {
	const chartContainerRef = useRef();

	const defaultProps = {
		symbol: '8eDUwKfT5tDDvEiL8JY6Pbssk58eNSwhBUGKQRdsTKWs',
		interval: '5',
		datafeedUrl: DATA_FEED_URL,
		libraryPath: '/charting_library/',
		chartsStorageApiVersion: '1.1',
		clientId: 'tradingview.com',
		userId: 'public_user_id',
		fullscreen: false,
		autosize: true,
		studies_overrides: {
			"volume.volume.color.0": "#00000000", // Hide the volume bars by setting the color to transparent
			"volume.volume.color.1": "#00000000"
		},
	};

	useEffect(() => {
		const symbol = getSymbolFromURL() || '8eDUwKfT5tDDvEiL8JY6Pbssk58eNSwhBUGKQRdsTKWs'
		const widgetOptions = {
			symbol ,
			datafeed: new CustomDataFeed(DATA_FEED_URL,WS_URL, symbol),//dtFeed,
			theme: getThemeFromURL() || 'dark',
			interval: '5',
			container: chartContainerRef.current,
			library_path: '/charting_library/',
			locale: getLanguageFromURL() || 'en',
			disabled_features: ['study_templates','use_localstorage_for_settings', 'volume_force_overlay', 'create_volume_indicator_by_default', 'create_volume_indicator_by_default_once'], // Disable volume feature
			// enabled_features: ['study_templates'],
			charts_storage_url: defaultProps.chartsStorageUrl,
			charts_storage_api_version: defaultProps.chartsStorageApiVersion,
			client_id: defaultProps.clientId,
			user_id: defaultProps.userId,
			fullscreen: defaultProps.fullscreen,
			autosize: defaultProps.autosize,
			debug: !!process.env.DEBUG,
			studies_overrides: defaultProps.studiesOverrides,
			
		};

		const tvWidget = new Widget(widgetOptions);
		// setWidget(tvWidget);

		return () => {
			tvWidget.remove();
		};
	}, []);

	return (
		<div
			ref={chartContainerRef}
			className={'TVChartContainer'}
		/>
	);
}
